import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
class SignalRController {

    constructor(props) {

        let url = "/AgentServer/hub",
            hostName = window.location.hostname;

        //! TODO: Trampa
        if (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === 'dev.andrei.io')
            url = "https://devomni.fidelitycloud.es/AgentServer/hub";

        this.connection = new HubConnectionBuilder()
            .withUrl(url)
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Information)
            .build();
    };

    connect = async () => {
        await this.connection.start().catch(err => {
            console.log("CONNECTION ERROR");

            setTimeout(() => {
                this.connect();
            }, 5000);
        });
    };

    disconnect = () => {
        this.connection.stop();
    };

    registerConnectionClosed = (callback) => {
        this.connection.onclose((message) => {
            console.error("*******************\n* SOCKET DISCONNECTED.\n*******************");
            callback(message);
            this.connect();
        });
    };

    registerAssociateResultEvent = (callback) => {
        this.connection.on('AssociateResult', callback);
    };

    registerCTIEvent = (callback) => {
        this.connection.on('CTIEvent', call => {
            //call.interactionType = "phone";
            callback(call);
        });
    };

    registerACDEvent = (callback) => {
        this.connection.on('ACDEvent', callback);
    };

    registerFunctionsEvent = (callback) => {
        this.connection.on('FunctionsEvent', message => {
            callback(message);
        });
    };

    registerPausesListEvent = (callback) => {
        this.connection.on('PausesList', message => {
            callback(message);
        });
    };

    registerGroupListEvent = (callback) => {
        this.connection.on('GroupsList', message => {
            callback(message);
        });
    };

    registerAgentsListEvent = (callback) => {
        this.connection.on('AgentsList', message => {
            callback(message);
        });
    };

    mail = (callback) => {
        this.connection.on('MailEvent', message => {
            callback(message);
        });
    };

    registerConnectedResult = (callback) => {
        this.connection.on('ConnectedResult', message => {
            console.log("*******************\n* SOCKET CONNECTED.\n*******************");
            callback(message);
        });
    };

    registerQueuesEvent = (callback) => {
        this.connection.on('QueuesEvent', message => {
            callback(message);
        });
    };

    registerPasswordExpiredEvent = (callback) => {
        this.connection.on('PasswordExpired', message => {
            console.log('PasswordExpired');
            callback(message);

        });
    };

    registerChannelsList = (callback) => {
        this.connection.on('ChannelsList', message => {
            callback(message);
        });
    };

    registerCategoriesList = (callback) => {
        this.connection.on('CategoriesList', message => {
            callback(message);
        });
    };
    registerURLEvent = (callback) => {
        this.connection.on('URLEvent', message => {
            callback(message);
        });
    };

    registerJanusInboundCall = (callback) => {
        this.connection.on('JanusInboundCall', message => {
            callback(message);
        });
    };

    registerOmniChannelInteractionsList = (callback) => {
        this.connection.off("OmniChannelInteractionsList")
        this.connection.on('OmniChannelInteractionsList', message => {
            try {
                callback(message);
            } catch (error) {
                console.error(error);
            }

        });
    };

    registerGetApp = (callback) => {
        this.connection.on('GetApp', message => {
            callback(message);
        });
    };

    registerRecoverPassword = (callback) => {
        this.connection.on('RecoverPassword', message => {
            callback(message);
        });
    };

    registerResend = (callback) => {
        this.connection.on('ResendTwoFactorToken', message => {
            callback(message);
        });
    };

    registerAddressBookFields = (callback) => {
        this.connection.on('AddressBookFields', message => {
            callback(message);
        });
    };

    registerContactsList = (callback) => {
        this.connection.on('ContactsList', message => {
            callback(message);
        });
    };

    registerFavoritesList = (callback) => {
        this.connection.on('FavoritesList', message => {
            callback(message);
        });
    };

    registerContactResult = (callback) => {
        this.connection.on('ContactResult', message => {
            callback(message);
        });
    };

    registerMailsList = (callback) => {
        this.connection.on('MailsList', message => {
            callback(message);
        });
    };

    registerMailCredentials = (callback) => {
        this.connection.on('MailCredentials', message => {
            callback(message);
        });
    };

    associateMessage = (message, error) => {
        this.connection.invoke('Associate', message).catch(data => {
            error();
        });
    };

    disassociateMessage = (message, error) => {
        this.connection.invoke('Disassociate', message).catch(data => {
            error();
        });
    };

    loginACD = (message, error) => {
        this.connection.invoke('LoginACD', message).catch(data => {
            error();
        });
    };

    logoutACD = (message, error) => {
        this.connection.invoke('LogoutACD', message).catch(data => {
            error();
        });
    };

    nextACD = (message, error) => {
        this.connection.invoke('NextACD', message).catch(data => {
            error();
        });
    };

    getPausesList = (message, error) => {
        this.connection.invoke('GetPauses', message).catch(data => {
            error();
        });
    };

    pauseACD = (message, error) => {
        this.connection.invoke('PauseACD', message).catch(data => {
            error();
        });
    };

    answer = (message, error) => {
        this.connection.invoke('Answer', message).catch(data => {
            error();
        });
    };

    hangup = (message, error) => {
        this.connection.invoke('Hangup', message).catch(data => {
            error();
        });
    };

    hold = (message, error) => {
        this.connection.invoke('Hold', message).catch(data => {
            error();
        });
    };

    retrieve = (message, error) => {
        this.connection.invoke('Retrieve', message).catch(data => {
            error();
        });
    };

    stopRecording = (message, error) => {
        this.connection.invoke('StopRecording', message).catch(data => {
            error();
        });
    };

    startRecording = (message, error) => {
        this.connection.invoke('StartRecording', message).catch(data => {
            error();
        });
    };

    setSDP = (message, error) => {
        this.connection.invoke('setSDP', message).then(() => {         
            const event = new Event('sdpSent');
            document.dispatchEvent(event);
        }).catch(data => {
            error();
        });
    };

    makeCall = (message, error) => {
        this.connection.invoke('MakeCall', message).catch(data => {
            error();
        });
    };

    consultation = (message, error) => {
        this.connection.invoke('Consultation', message).catch(data => {
            error();
        });
    };

    redirect = (message, error) => {
        this.connection.invoke('Redirect', message).catch(data => {
            error();
        });
    };

    makeCallGroup = (message, error) => {
        this.connection.invoke('MakeCallGroup', message).catch(data => {
            error();
        });
    };

    getGroups = (message, error) => {
        this.connection.invoke('GetGroups', message).catch(data => {
            error();
        });
    };

    getAgents = (message, error) => {
        this.connection.invoke('GetAgents', message).catch(data => {
            error();
        });
    };

    isConnected = async () => {
        return this.connection.connectionId != null;
    };

    transference = (message, error) => {
        this.connection.invoke('Transference', message).catch(data => {
            error();
        });
    };

    swap = (message, error) => {
        this.connection.invoke('Swap', message).catch(data => {
            error();
        });
    };

    conference = (message, error) => {
        this.connection.invoke('Conference', message).catch(data => {
            error();
        });
    };

    setUserPassword = (message, error) => {
        this.connection.invoke('SetUserPassword', message).catch(data => {
            error();
        });
    };

    setMailPassword = (message, error) => {
        this.connection.invoke('SetMailPassword', message).catch(data => {
            error();
        });
    };

    enableQueue = (message, error) => {
        this.connection.invoke('EnableQueue', message).catch(data => {
            error();
        });
    };

    getChannels = (message, error) => {
        this.connection.invoke('GetChannels', message).catch(data => {
            error();
        });
    }

    enableChannel = (message, error) => {
        this.connection.invoke('EnableChannel', message).catch(data => {
            error();
        });
    }

    getCategories = (message, error) => {
        this.connection.invoke('GetCategories', message).catch(data => {
            error();
        });
    }

    setCallCategory = (message, error) => {
        this.connection.invoke('SetCallCategory', message).catch(data => {
            error();
        });
    }

    getOmniChannelInteractions = (message, error) => {
        this.connection.invoke('GetOmniChannelInteractions', message).catch(data => {
            error();
        });
    }

    twoFactorAssociate = (message, error) => {
        this.connection.invoke('TwoFactorAssociate', message).catch(data => {
            error();
        });
    };

    getApp = (message, error) => {
        this.connection.invoke('GetApp', message).catch(data => {
            error();
        });
    };

    recoverPassword = (message, error) => {
        this.connection.invoke('RecoverPassword', message).catch(data => {
            error();
        });
    };

    resend = (message, error) => {
        this.connection.invoke('ResendTwoFactorToken', message).catch(data => {
            error();
        });
    };

    functionButton = (message, error) => {
        this.connection.invoke('FunctionButton', message).catch(data => {
            error();
        });
    };

    janusLog = (message, error) => {
        this.connection.invoke('JanusLog', message).catch(data => {
            error();
        });
    };

    consoleLog = (message, error) => {
        this.connection.invoke('ConsoleLog', message).catch(data => {
            error();
        });
    };

    makeCallCamp = (message, error) => {
        this.connection.invoke('MakeCallCamp', message).catch(data => {
            error();
        });
    };

    setFormChange = (message, error) => {
        this.connection.invoke('SetFormChange', message).catch(data => {
            error();
        });
    };

    muteRecording = (message, error) => {
        this.connection.invoke('MuteRecording', message).catch(data => {
            error();
        });
    };

    getAddressBookFields = (message, error) => {
        this.connection.invoke('GetAddressBookFields', message).catch(data => {
            error();
        });
    };

    getContacts = (message, error) => {
        this.connection.invoke('GetContacts', message).catch(data => {
            error();
        });
    };

    getFavorites = (message, error) => {
        this.connection.invoke('GetFavorites', message).catch(data => {
            error();
        });
    };

    setFavorite = (message, error) => {
        this.connection.invoke('SetFavorite', message).catch(data => {
            error();
        });
    };

    deleteContact = (message, error) => {
        this.connection.invoke('DeleteContact', message).catch(data => {
            error();
        });
    };

    getMailCredentials = (message, error) => {
        this.connection.invoke('GetMailCredentials', message).catch(data => {
            error();
        });
    };

    associatedContact = (message, error) => {
        this.connection.invoke('AssociatedContact', message).catch(data => {
            error();
        });
    };
    getMails = (message, error) => {
        this.connection.invoke('getMails', message).catch(data => {
            error();
        });
    };
}

const signalRService = new SignalRController();
export default signalRService;